import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { GruposPage } from '../pages/grupos/grupos';
import { GruposPageModule } from '../pages/grupos/grupos.module';
import { HttpServiceProvider } from '../providers/http-service/http-service';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { AdicionarProdutoPage } from '../pages/adicionar-produto/adicionar-produto';
import { AlertProvider } from '../providers/alert/alert';
import { CartService } from '../pages/cart.service';
import { ToastProvider } from '../providers/toast/toast';
import { ListarcomandaPage } from '../pages/listarcomanda/listarcomanda';
import { CurrencyPipe } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { Geolocation } from '@ionic-native/geolocation';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { File } from '@ionic-native/file'

registerLocaleData(localePtBr);

@NgModule({
  declarations: [
    MyApp,
    AdicionarProdutoPage,
    ListarcomandaPage
  ],
  imports: [
    BrMaskerModule,
    BrowserModule,
    GruposPageModule,
    HttpClientModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {
      scrollPadding: false,
      scrollAssist: true,
      autoFocusAssist: false
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp, 
    GruposPage,
    AdicionarProdutoPage,
    ListarcomandaPage
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {
      provide: LOCALE_ID,
      useValue: "pt-BR"
    }, 
    CurrencyPipe,
    HttpServiceProvider,
    AlertProvider,
    CartService,
    ToastProvider,
    Geolocation,
    LaunchNavigator,
    File
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts